import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

export default function PrivateRoute({ children }) {
  const userToken = localStorage.getItem("authToken");
  const location = useLocation();

  if (!userToken ) {
    // console.log('Unauthorized user! Token might be expired, please login again.');
    return <Navigate to="/" replace state={{ from: location }} />;
  }

  // console.log('UserToken in Private Route', userToken);
  return children;
}
